import React, { useState, useEffect } from 'react';
import { Table, Button, Tag, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { jadeTypeApi } from '../../services/api';

const JadeTypes = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0 });
  const navigate = useCompanyNavigate();

  useEffect(() => {
    fetchList();
  }, [pagination.page, pagination.limit]);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await jadeTypeApi.list({ page: pagination.page, limit: pagination.limit });
      setList(res.data.list);
      setPagination(p => ({ ...p, total: res.data.pagination.total }));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await jadeTypeApi.delete(id);
      message.success('删除成功');
      fetchList();
    } catch (err) {
      message.error(err.message || '删除失败');
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 60,
    },
    {
      title: '料种名称',
      dataIndex: 'name',
    },
    {
      title: '产地',
      dataIndex: 'origin',
    },
    {
      title: '状态',
      dataIndex: 'is_active',
      render: (val) => (
        <Tag color={val === 1 ? 'green' : 'red'}>
          {val === 1 ? '启用' : '禁用'}
        </Tag>
      ),
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      render: (val) => val ? new Date(val).toLocaleDateString() : '-',
    },
    {
      title: '操作',
      key: 'action',
      width: 150,
      render: (_, record) => (
        <>
          <Button
            type="link"
            size="small"
            icon={<EditOutlined />}
            onClick={() => navigate(`/admin/jade-types/${record.id}/edit`)}
          >
            编辑
          </Button>
          <Popconfirm
            title="确定删除此料种吗？"
            onConfirm={() => handleDelete(record.id)}
            okText="确定"
            cancelText="取消"
          >
            <Button type="link" size="small" danger icon={<DeleteOutlined />}>
              删除
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2>料种管理</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate('/admin/jade-types/new')}
          style={{ background: '#8B7355' }}
        >
          新增料种
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={list}
        rowKey="id"
        loading={loading}
        pagination={{
          current: pagination.page,
          pageSize: pagination.limit,
          total: pagination.total,
          onChange: (page) => setPagination(p => ({ ...p, page })),
        }}
      />
    </div>
  );
};

export default JadeTypes;